export default "__VITE_ASSET__CtiMPB_u__"